import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import CloseIcon from './close.svg';

import style from './CloseButton.scss';

const cn = bemCssModules(style, 'CloseButton');
const ti = getTestId('CloseButton');

export type TCloseButton = {
  onClick?: () => void;
};

const CloseButton: CustomFC<TCloseButton> = ({ className, onClick }) => {
  return (
    <button
      className={cn(null, [className])}
      data-testid={ti()}
      type="button"
      aria-label="Close"
      onClick={onClick}
    >
      <CloseIcon />
    </button>
  );
};

export default CloseButton;
